import gql from 'graphql-tag';

const getYachtForCharterContactDataQuery = queryName => gql`
  query getContactData($id: String!) {
    data: getPublishedYachtForCharter(id: $id) {
      id
      businessContactComponentContacts {
        brokerBranchId
        brokerId
        brokerName
        businessContactId
        exhibitorId
        image {
          id
          url
          data
          name
        }
        internalUrl
        name
        phone
        website
        isSponsored
        listingState
      }
      name
      yachtForCharterId: id
      price
      formattedPrice
      currency {
        id
        code
      }
      publishedBrokers {
        id
        name
      }
      length_overall
      built_on_year
      formattedState
      weeklyLowRate
      category {
        id
        name
      }
      image {
        id
        url
        filename
      }
      publishedExhibitors {
        id
        name
      }
      publishedBuilderProfiles {
        id
        name
      }
      brokerListingLinks {
        url
        brokerId
      }
      brokerIds
    }
  }
`;

export default getYachtForCharterContactDataQuery;
